// Shared "What are you most interested in?" options used across every
// contact/inquiry form on the site.
export const INQUIRY_INTERESTS = [
  "Real Estate — Buying",
  "Real Estate — Selling",
  "Become a Real Estate Agent",
  "Introduction to Our Brokerage",
  "1:1 Coaching",
  "1:1 Consultation — Mental & Emotional Release",
  "Cornerstone Advantage Program",
  "Leadership Coaching",
  "Let's Just Talk / General Question",
  "Other",
];
